(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./index.less", "../_mixins/vantSlots", "../_util/vantEvent", "../_util/vantScroll", "../_mixins/vantTouch", "../_style/images/inlineLoadingGif"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./index.less"), require("../_mixins/vantSlots"), require("../_util/vantEvent"), require("../_util/vantScroll"), require("../_mixins/vantTouch"), require("../_style/images/inlineLoadingGif"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.index, global.vantSlots, global.vantEvent, global.vantScroll, global.vantTouch, global.inlineLoadingGif);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _index, _vantSlots, _vantEvent, _vantScroll, _vantTouch, _inlineLoadingGif) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var DEFAULT_HEAD_HEIGHT = 50;
  var MAX_PULL_DOWN_HEIGHT = 460; //下拉最大距离

  var TEXT_STATUS = ['pulling', 'loosing', 'success'];
  var _default = {
    name: 'nx-pull-refresh',
    mixins: [_vantTouch.TouchMixin, _vantSlots.SlotsMixin],
    props: {
      disabled: Boolean,
      successText: String,
      pullingText: String,
      loosingText: String,
      loadingText: {
        type: String,
        default: '正在刷新...'
      },
      value: {
        type: Boolean,
        required: true
      },
      successDuration: {
        type: [Number, String],
        default: 300
      },
      animationDuration: {
        type: [Number, String],
        default: 350
      },
      headHeight: {
        type: [Number, String],
        default: DEFAULT_HEAD_HEIGHT
      },
      loadingType: {
        type: String,
        default: 'swivel-image'
      }
    },
    data: function data() {
      return {
        status: 'normal',
        distance: 0,
        duration: 0
      };
    },
    computed: {
      touchable: function touchable() {
        return this.status !== 'loading' && this.status !== 'success' && !this.disabled;
      },
      headStyle: function headStyle() {
        if (this.distance <= this.headHeight) {
          return {
            height: "".concat(this.headHeight, "px")
          };
        }

        return {
          height: "".concat(this.distance, "px")
        };
      },
      // 环形进度条周长
      circum: function circum() {
        return 48 * Math.PI;
      },
      // 环形进度条进度
      progress: function progress() {
        var rate = this.distance >= MAX_PULL_DOWN_HEIGHT ? 0 : this.distance / MAX_PULL_DOWN_HEIGHT;
        return (1 - rate) * this.circum;
      }
    },
    watch: {
      value: function value(loading) {
        this.duration = this.animationDuration;

        if (loading) {
          this.setStatus(+this.headHeight, true);
        } else if (this.slots('success') || this.successText) {
          this.showSuccessTip();
        } else {
          this.setStatus(0, false);
        }
      }
    },
    mounted: function mounted() {
      this.bindTouchEvent(this.$refs.track);
      this.scrollEl = (0, _vantScroll.getScroller)(this.$el);
    },
    methods: {
      checkPullStart: function checkPullStart(event) {
        this.ceiling = (0, _vantScroll.getScrollTop)(this.scrollEl) === 0;

        if (this.ceiling) {
          this.duration = 0;
          this.touchStart(event);
        }
      },
      onTouchStart: function onTouchStart(event) {
        if (this.touchable) {
          this.checkPullStart(event);
        }
      },
      onTouchMove: function onTouchMove(event) {
        if (!this.touchable) {
          return;
        }

        if (!this.ceiling) {
          this.checkPullStart(event);
        }

        this.touchMove(event);

        if (this.ceiling && this.deltaY >= 0 && this.direction === 'vertical') {
          (0, _vantEvent.preventDefault)(event);
          this.setStatus(this.ease(this.deltaY));
        }
      },
      onTouchEnd: function onTouchEnd() {
        var _this = this;

        if (this.touchable && this.ceiling && this.deltaY) {
          this.duration = this.animationDuration;

          if (this.status === 'loosing') {
            this.setStatus(+this.headHeight, true);
            this.$emit('input', true); // ensure value change can be watched

            this.$nextTick(function () {
              _this.$emit('refresh');
            });
          } else {
            this.setStatus(0);
          }
        }
      },
      ease: function ease(distance) {
        var headHeight = +this.headHeight;

        if (distance > headHeight) {
          if (distance < headHeight * 2) {
            distance = headHeight + (distance - headHeight) / 2;
          } else {
            distance = headHeight * 1.5 + (distance - headHeight * 2) / 4;
          }
        }

        return Math.min(Math.round(distance), MAX_PULL_DOWN_HEIGHT);
      },
      setStatus: function setStatus(distance, isLoading) {
        var status;

        if (isLoading) {
          status = 'loading';
        } else if (distance === 0) {
          status = 'normal';
        } else {
          status = distance < this.headHeight ? 'pulling' : 'loosing';
        }

        this.distance = distance;

        if (status !== this.status) {
          this.status = status;
        }
      },
      genStatus: function genStatus() {
        var h = this.$createElement;
        var status = this.status,
            distance = this.distance;
        var slot = this.slots(status, {
          distance: distance
        });

        if (slot) {
          return slot;
        }

        var nodes = [];
        var text = this["".concat(status, "Text")];

        if (this.pullingText ? TEXT_STATUS.indexOf(status) !== -1 : status === 'success') {
          nodes.push(h("div", {
            "class": "nx-pull-refresh-text"
          }, [" ", text, " "]));
        } else if (['pulling', 'loosing'].includes(status) && !this.pullingText) {
          // os5.0: 刷新区域的环形进度条
          nodes.push(h("div", {
            "class": "nx-pull-refresh-text"
          }, [h("svg", {
            "attrs": {
              "viewBox": "0 0 24 24",
              "xmlns": "http://www.w3.org/2000/svg"
            }
          }, [h("ellipse", {
            "class": "bck",
            "attrs": {
              "cx": "12",
              "cy": "12",
              "rx": "6.5",
              "ry": "6.5",
              "fill-opacity": "0",
              "fill": "none",
              "stroke-width": "2.799999952316284",
              "stroke": "rgba(60, 69, 93, 0.4)"
            }
          }), h("ellipse", {
            "class": "line",
            "attrs": {
              "cx": "12",
              "cy": "12",
              "rx": "6.5",
              "ry": "6.5",
              "fill-opacity": "0",
              "stroke-opacity": "1",
              "stroke": "#3C455D",
              "fill": "none",
              "stroke-width": "2.799999952316284",
              "stroke-dasharray": this.circum,
              "stroke-dashoffset": this.progress
            }
          })])]));
        }

        if (status === 'loading') {
          var _map = {
            'swivel-image': _inlineLoadingGif.inlineLoadingGif,
            'swivel-image-blue': _inlineLoadingGif.inlineLoadingGifBlue
          };
          nodes.push(h("div", {
            "key": "loading",
            "class": "nx-pull-refresh-loading"
          }, [h("img", {
            "class": "nx-inline-loading-gif",
            "attrs": {
              "src": _map[this.loadingType]
            }
          })]));
        }

        return nodes;
      },
      showSuccessTip: function showSuccessTip() {
        var _this2 = this;

        this.status = 'success';
        setTimeout(function () {
          _this2.setStatus(0);
        }, this.successDuration);
      }
    },
    render: function render() {
      var h = arguments[0];
      var trackStyle = {
        transitionDuration: "".concat(this.duration, "ms"),
        transform: this.distance ? "translate3d(0,".concat(this.distance, "px, 0)") : '',
        transitionTimingFunction: 'cubic-bezier(0.28, 0.15, 0.2, 1.0)'
      };
      return h("div", {
        "class": "nx-pull-refresh"
      }, [h("div", {
        "ref": "track",
        "class": "nx-pull-refresh-track",
        "style": trackStyle
      }, [h("div", {
        "class": "nx-pull-refresh-head",
        "style": this.headStyle
      }, [this.genStatus()]), this.slots()])]);
    }
  };
  _exports.default = _default;
});